import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { uploadPreSignedUrl } from "constants/apiUrls";

// API Response Type
export interface PreSignedUrlResponse {
  url: string; // S3 bucket URL
  fields: {
    // AWS S3 required fields
    key: string; // File path/name in S3
    AWSAccessKeyId: string;
    policy: string; // Base64 encoded policy
    signature: string; // AWS signature
  };
  uuid: string; // Unique identifier for the uploaded image
}

const imageUploadApi = createApi({
  reducerPath: "imageUploadApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      headers.set("bludot-app-name", "business-rewards");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPreSignedUrl: builder.mutation<
      PreSignedUrlResponse,
      { imageUuid?: string }
    >({
      query: (data) => ({
        url: uploadPreSignedUrl,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useGetPreSignedUrlMutation } = imageUploadApi;
export default imageUploadApi;
